var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 40 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    x: 20,
    y: 20,
    fill: "#1F72CD",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.171 29.917 23.43 38.37h4.48l.555-1.348h1.27l.555 1.348h4.932v-1.029l.44 1.03h2.55l.44-1.051v1.05h10.256l1.247-1.313 1.168 1.313 5.268.011-3.755-4.214 3.755-4.251h-5.186l-1.214 1.288-1.131-1.288H37.9l-.958 2.182-.98-2.182h-4.471v.994l-.498-.994zm15.316 1.2h5.89l1.801 1.987 1.86-1.987h1.8l-2.736 3.05 2.737 3.013h-1.883l-1.802-2.01-1.869 2.01h-5.798zm1.454 2.364v-1.108h3.675l1.603 1.77-1.674 1.781H43.94v-1.209h3.213v-1.234zm-15.903-2.364h2.184l2.483 5.733v-5.733h2.392l1.917 4.11 1.767-4.11h2.38v6.067h-1.448l-.011-4.754-2.112 4.754h-1.296l-2.123-4.754v4.754h-2.98l-.565-1.36h-3.052l-.564 1.359h-1.596zm.057 3.45 1.006-2.423 1.004 2.422z",
    clipRule: "evenodd"
  })));
};
export default SvgAmex;